import { Logo } from '../components/Logo'
import { Usda } from '../components/Usda';
import {
  PageContainer,
  HeroSection,
  HeroContent,
  BackLink,
  ContentSection,
  Container,
  MainContent,
  SideContent,
  ProductTitle,
  ProductSubtitle,
  SectionTitle,
  SubSectionTitle,
  Paragraph,
  InfoTable,
  TableRow,
  TableDataLabel,
  TableData,
  List,
  AcoContainer,
  DecorativeElement
} from './ProductStyles';

export const BoswelliaCarterii17 = () => (
  <PageContainer>
    <HeroSection>
      <BackLink to="/">ホームに戻る</BackLink>
      <HeroContent>
        <Logo />
      </HeroContent>
    </HeroSection>

    <ContentSection>
      <Container>
        <MainContent>
          <DecorativeElement className="top-right" />
          <DecorativeElement className="bottom-left" />

          <ProductTitle>フランキンセンス (ロット17)</ProductTitle>
          <ProductSubtitle>Boswellia carterii</ProductSubtitle>

          <SectionTitle>使用期限</SectionTitle>
          <Paragraph>{new Date('2027-06-30T00:00:00.000+09:00').toLocaleDateString()}</Paragraph>

          <SectionTitle>製品の特徴</SectionTitle>
          <InfoTable>
            <tbody>
              <TableRow>
                <TableDataLabel>原産国</TableDataLabel>
                <TableData>ソマリア</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出部位</TableDataLabel>
                <TableData>樹脂（ガム）</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出方法</TableDataLabel>
                <TableData>水蒸気蒸留法</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>学名</TableDataLabel>
                <TableData>Boswellia carterii</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>科名</TableDataLabel>
                <TableData>カンラン科</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>効果</TableDataLabel>
                <TableData>瞑想、スキンケア、リラクゼーション</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>INCI名</TableDataLabel>
                <TableData>Boswellia Carterii (Frankincense) Oil</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>CAS番号</TableDataLabel>
                <TableData>8016-36-2 ; 89957-98-2</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>品質</TableDataLabel>
                <TableData>100% Pure and Natural</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>ノート分類</TableDataLabel>
                <TableData>ベースノート（優れた定着剤）</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>ロット番号</TableDataLabel>
                <TableData>17</TableData>
              </TableRow>
            </tbody>
          </InfoTable>

          <SectionTitle>分析証明書</SectionTitle>

          <SubSectionTitle>製品識別と組成</SubSectionTitle>
          <List>
            <li>製品名: Frankincense Essential Oil 100% Pure and Natural (ロット17)</li>
            <li>学名: Boswellia carterii</li>
            <li>バッチ番号: 10742512</li>
          </List>

          <SubSectionTitle>物理的および化学的特性</SubSectionTitle>
          <List>
            <li>外観: 淡黄色から淡琥珀色の液体</li>
            <li>香り: 幽玄でウッディ、バルサミック、広がりのあるアロマにレモン調シトラスのトップノート</li>
            <li>屈折率: 1.471 @ 20°C</li>
            <li>比重: 0.873 @ 20°C</li>
            <li>旋光度: -26° 〜 +10°</li>
            <li>溶解性: アルコール類および固定油に可溶、水に不溶</li>
          </List>

          <SubSectionTitle>主要成分（EU アレルゲン申告）</SubSectionTitle>
          <List>
            <li>ピネン (Pinene): 54.0%</li>
            <li>リモネン (Limonene): 19.0%</li>
            <li>β-カリオフィレン (Beta-Caryophyllene): 3.2%</li>
            <li>テルピネオール (Terpineol): 0.6%</li>
            <li>テルピノレン (Terpinolene): 0.3%</li>
            <li>リナロール (Linalool): 0.3%</li>
            <li>α-テルピネン (Alpha-Terpinene): 0.2%</li>
            <li>カンファー (Camphor): 0.2%</li>
          </List>

          <SubSectionTitle>品質検査</SubSectionTitle>
          <List>
            <li>微生物検査: 全項目適合（ISO 21149, ISO 16212, ISO 18416, ISO 21150, ISO 22717, ISO 22718）</li>
            <li>重金属検査: 全項目適合（鉛 &lt; 10ppm、ヒ素 &lt; 2ppm、水銀 &lt; 1ppm）</li>
            <li>IFRA適合: 第51次改正（2023年7月公布）準拠</li>
          </List>

          <SubSectionTitle>保管方法</SubSectionTitle>
          <Paragraph>密閉容器に入れ、直射日光を避けて冷暗所に保管してください。24ヶ月以上保管した場合は、使用前に品質を確認してください。</Paragraph>
        </MainContent>

        <SideContent>
          <AcoContainer>
            <Usda />
          </AcoContainer>
        </SideContent>
      </Container>
    </ContentSection>
  </PageContainer>
);
